import { Component, OnDestroy, OnInit } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';

import { ProgressBarModule } from 'primeng/progressbar';
import { StrategyService } from '../app/services/strategy.service';
import { Pillar, Strategy } from '../app/interfaces/models/strategy.model';
import { SocketService } from '../app/services/socket.service';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DirectionService } from '../app/services/direction.service';
import { CommonModule } from '@angular/common';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { NotificationService } from '../app/services/notification.service';
import { authUser, INotification } from '../app/interfaces';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SinceDatePipe } from '../app/pipes/since-date.pipe';
import { TagModule } from 'primeng/tag';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { AuthService } from '../app/services/auth.service';
import { IndicatorsChartsComponent } from '../app/components/indicators-charts/indicators-charts.component';
import { TabViewModule } from 'primeng/tabview';
import { TasksComponent } from '../app/components/tasks/tasks.component';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { NotificationsComponent } from '../app/shared/components/notifications/notifications.component';
import { GoalTreeComponent } from '../app/shared/goal-tree/goal-tree.component';
const weightColors = {
  25: "#cc3300",
  20: "#ff9966",
  15: "#ffcc00",
  10: "#99cc33",
  5: "#339900",
  1: "#28a745"
}

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [NotificationsComponent, GoalTreeComponent, SidebarModule, ProgressBarModule, DialogModule, TasksComponent, TabViewModule, IndicatorsChartsComponent, RouterModule, SinceDatePipe, TableModule, TranslateModule, TagModule, CommonModule, DropdownModule, ButtonModule, FormsModule],
  templateUrl: './strategy-exec.component.html',
  styleUrl: './strategy-exec.component.scss'
})
export class StrategyExecComponent implements OnInit, OnDestroy {
  strategyOptions = [] as { name: string, strategyId: number }[];
  selectedStrategyId = 0;
  tabletype = 'goalsAndIndicators'
  isVisibleGoalModal = false;
  selectedStrategy = {} as Strategy;
  alignmentStrategy = {} as any;
  selectedPillar = { id: 0 } as any;
  dir!: "rtl" | "ltr";
  notifications = [] as INotification[];
  pillars = [] as any
  toggleStates: { [goalId: number]: boolean } = {};
  isModalVisible = false
  project = {} as any
  selectedProject = {} as any
  user!: authUser;
  selectedNotificaton = {} as any
  isAllNotificationsVisible = false;
  NotificationTypesEnum = {
    submission_request: "submission_request",
    submission_response: "submission_response",
    milestone_output_audit_request: "milestone_output_audit_request",
    milestone_output_audit_response: "milestone_output_audit_response",
    outcome_proof_audit_request: "outcome_proof_audit_request",
    outcome_proof_audit_response: "outcome_proof_audit_response"
  }
  constructor(
    private strategyService: StrategyService,

    private directionService: DirectionService,
    private socketService: SocketService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,

    private authService: AuthService
  ) {


  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private unsubscribe$ = new Subject<void>();
  ngOnInit(): void {

    this.authService.authBufferSub$.pipe(takeUntil(this.unsubscribe$)).subscribe((user) => {
      this.user = user as authUser;
    })
    this.route.data.pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ viewBag }) => {
        this.strategyOptions = viewBag.stratgies.map((x: any) => ({ name: x.name, strategyId: x.id }))
        this.strategyService.setStrategyIdfn(this.selectedStrategyId)
        this.alignmentStrategy = viewBag.strategyAlignment['data']['strategy'];
        this.pillars = [...this.alignmentStrategy.pillars]
        this.selectedStrategyId = this.alignmentStrategy.id;
        this.selectedStrategy = this.alignmentStrategy as Strategy;
        this.pillars = [...this.alignmentStrategy.pillars]
        
        // Set first pillar as default
        if (this.alignmentStrategy?.pillars?.length > 0) {
          this.selectedPillar = this.alignmentStrategy.pillars[0];
        }
      })
    this.socketService.refreshNotification$.subscribe((response: any) => {
      this.notifications = response["data"]["notifications"];

    });
    this.directionService.direction$.pipe(takeUntil(this.unsubscribe$)).subscribe(dir => {
      this.dir = dir;
    })
  }
  strategyOptionsChange() {
    this.strategyService.getStrategyById(this.selectedStrategyId.toString()).pipe(takeUntil(this.unsubscribe$)).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;
      this.strategyService.getStrategyAlignment(this.selectedStrategyId.toString()).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
        this.alignmentStrategy = response['data']['strategy'];
        this.pillars = [...this.alignmentStrategy.pillars]
        this.selectedPillar = { id: 0 }
      })
    })
    this.socketService.setRefreshNotification(this.selectedStrategyId)
  }
  gotoAddProject() {

  }
  selectPillarFn(pillar: any) {
    this.toggleStates = {};
    if (!Object.keys(pillar).length) {
      this.selectedPillar = { id: 0 };
      this.pillars = []
      this.pillars = [...this.alignmentStrategy.pillars]
    } else {
      this.pillars = []
      this.pillars.push(pillar)
      this.selectedPillar = pillar;

    }
  }

  markAsRead(notificationId: number) {
    const notification = this.notifications.find(n => n.id == notificationId) as INotification
    if (notification.is_read) {
      return;
    } else {

      this.notificationService.markAsRead(notificationId).pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
        notification["is_read"] = true
      })
    }
  }

  navigateToEntity(notification: INotification) {
    if (notification.type == 'assessment_response' || notification.type == 'submission_request') {
      // this.router.navigateByUrl(`strategies/${this.se}/projects/48`)
    }
  }

  onToggle(goalId: number): void {
    // Toggle the state for the specific goal
    this.toggleStates[goalId] = !this.toggleStates[goalId];
    console.log(this.toggleStates[goalId]);
  }

  isToggled(goalId: number): boolean {
    // Return true if the details element is toggled open, false otherwise
    return this.toggleStates[goalId] ?? false;
  }

  closeModal() {
    this.tabletype = 'goalsAndIndicators'
    this.isModalVisible = false;
  }

  tableType(tableType: string) {
    this.tabletype = tableType;
  }
  showModal(project: any) {
    this.selectedProject = project;
    this.strategyService.GetProjectPerformance(this.selectedStrategyId, project.id).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
      this.project = response['data'];
      console.log('this.project', this.project);
    })

    // this.strategyService.
    this.isModalVisible = true;
  }
  getWeightColor(weight: number) {
    if (weight == 1) return weightColors[1]
    if (weight > 1 && weight <= 5) return weightColors[5]
    if (weight > 5 && weight <= 10) return weightColors[10]
    if (weight > 10 && weight <= 15) return weightColors[15]
    if (weight > 15 && weight <= 20) return weightColors[20]
    if (weight > 20 && weight <= 25) return weightColors[25]
    return ''
  }
  visible = false
  selectNotification(notificationId: number) {
    console.log(notificationId);
    this.selectedNotificaton = this.notifications.find(x => x.id == notificationId);
    this.visible = true;
  }
  allNotifications() {
    this.isAllNotificationsVisible = true;
  }

  onPillarChange() {
    console.log('Selected pillar:', this.selectedPillar);
  }

  getTotalPillarsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.length;
  }

  getTotalGoalsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.length || 0);
    }, 0);
  }

  getTotalIndicatorsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.reduce((sum: number, goal: any) => sum + (goal.no_indicators || 0), 0) || 0);
    }, 0);
  }

  getTotalProjectsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.reduce((sum: number, goal: any) => sum + (goal.no_projects || 0), 0) || 0);
    }, 0);
  }
}


